import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { createQueryClient } from './api/index.js';
import { App } from './App.js';
import './styles/index.css';

// Server state via TanStack Query (architecture.md §5: replaces the old manual
// app.state + localStorage). Mounts the SPA into #root from index.html.
// Cache defaults live in api/queryClient.ts so they stay a single contract.
const queryClient = createQueryClient();

const rootEl = document.getElementById('root');
if (rootEl) {
  createRoot(rootEl).render(
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </StrictMode>,
  );
}
